
import axiosInstance from "../../axiosInstance";
import { normalizeApiError } from "utils/normalizeApiError";

export interface ReorderWorkItemPayload {
  projectUuid: string;
  workItemUuid: string;
  prevWorkItemUuid: string | null;
  nextWorkItemUuid: string | null;
  viewType: 'KANBAN' | 'LIST';
  newStatusUuid?: string;
  previousStatusUuid?: string;
  moveToTop?: boolean;
  moveToBottom?: boolean;
  // Required for a LIST reorder of an item that has a parent — the parent's
  // listVersion as last read. Ignored for top-level/Kanban reorders. A
  // mismatch is rejected with 409 REORDER_CONFLICT rather than guessed.
  expectedListVersion?: number;
}

export interface ReorderWorkItemResponse {
  status: boolean;
  message: string;
  // The moved item's parent's listVersion after this move — left out for
  // top-level and Kanban reorders. Use it as expectedListVersion for the
  // next reorder in the same list.
  listVersion?: number;
}

export const reorderWorkItem = async (
  payload: ReorderWorkItemPayload
): Promise<ReorderWorkItemResponse> => {
  try {
    const { data } = await axiosInstance.post<{ response: ReorderWorkItemResponse }>(
      "pmo/reorder-work-item",
      payload
    );

    if (data.response.status === false) {
      throw data.response;
    }

    return data.response;
  } catch (error) {
    throw normalizeApiError(error);
  }
};
